import axios, { AxiosPromise } from 'axios';
import { IAgreementCode } from '../../../@types/model/masterData/agreementCode/agreementCode';

export default class AgreementCodeHttpService {
    public static getAgreementCodeData() : AxiosPromise<Array<IAgreementCode>> {
        return axios.get(`${API_URL}/v1/AgreementCode/GetAllWeb`);
    }

    public static addOrUpdateAgreementCode(data : IAgreementCode) : AxiosPromise<IAgreementCode> {
        return axios.post(`${API_URL}/v1/AgreementCode/PostAgreementCode`, data);
    }

    public static syncAgreementCodes() : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1/AgreementCode/SyncAgreementCodes`);
    }
}
